export default "https://cdn-static.gokick.com/assets/6706629b3df14a4b3713b9aca1ff59a1c44b8347/images/sleep-bottles.21ff427124b73aa7b2cf5884e65ef589.jpg";